import axios from "./Api";
import { handleQueriesString } from "../helpers/function.helper";

export const GetSkuList = async (params: any) => {
  const queriesString = handleQueriesString(params);
  const url = `/api/app/stock-keeping-unit?MaxResultCount=40&${queriesString}`;
  const data = await axios.get(url);
  return data;
};

export const ProudctActionDetail = async (type: string, id: string) => {
  const types: string = type === "sku" ? "stock-keeping-unit" : type;
  const url = `/api/app/${types}/${id}`;
  const data = await axios.get(url);
  return data;
};

export const ManyToWarehouse = async (type: number, params: any) => {
  const url = `/api/app/product/many-to-warehouse?type=${type}`;
  const data = await axios.post(url, params);
  return data;
};

export const GetSkuId = async (skuId: string) => {
  const url = `/api/app/stock-keeping-unit/search-by-sku?term=${skuId}`;
  const data = await axios.post(url);
  return data;
};
